import React from 'react'
import { connect } from 'react-redux'
import CustomButton from '../shared/CustomButton'
import { prefix } from '../normalizer'

const tRegister = prefix('gamification2026.register')

const ThankYou = ({ client }) => {
  return (
    <div className="register-thankyou">
      <div className="register-thankyou__container">
        {client && client.logo && client.logo.url && (
          <div className="register-thankyou__logo">
            <img src={client.logo.url} alt="" />
          </div>
        )}
        <div className="register-thankyou__title">{tRegister('thank-you-title')}</div>
        <div className="register-thankyou__message">{tRegister('thank-you-message')}</div>
        <div className="register-thankyou__actions">
          <CustomButton link primary to="/login" className="register-thankyou__actions-button">
            {tRegister('back-to-login')}
          </CustomButton>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  loggedIn: state.userReducer.loggedIn,
  client: state.userReducer.client
})

export default connect(mapStateToProps, null)(ThankYou)
